import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { firstValueFrom, map, take } from 'rxjs';
import { CoreConfig } from 'src/app/models/core-config.model';
import { ProfilePipelineAccess } from 'src/app/models/user.model';

/** A quem o acesso às pipelines pertence: um perfil ou um usuário (bw_user). */
export type PipelineAccessOwner = 'profile' | 'user';

/**
 * Chamado #0000579137 — acesso por pipeline de IA (ver resultados / executar) de um perfil ou de um
 * usuário. Redline: `v1/profiles/{id}/pipelines` e `v1/bw-users/{id}/pipelines` (GET e PUT).
 */
@Injectable({ providedIn: 'root' })
export class PipelineAccessService {
  constructor(
    private http: HttpClient,
    @Inject('config') private config: CoreConfig
  ) {}

  private url(owner: PipelineAccessOwner, id: string): string {
    const resource = owner === 'profile' ? 'profiles' : 'bw-users';
    return `${this.config.apiUrl}/api/v1/${resource}/${id}/pipelines`;
  }

  list(owner: PipelineAccessOwner, id: string): Promise<ProfilePipelineAccess[]> {
    return firstValueFrom(
      this.http.get<{ data: ProfilePipelineAccess[] }>(this.url(owner, id)).pipe(
        take(1),
        map(response => response?.data ?? [])
      )
    );
  }

  save(
    owner: PipelineAccessOwner,
    id: string,
    pipelines: Pick<ProfilePipelineAccess, 'pipeline_id' | 'can_read' | 'can_execute'>[]
  ): Promise<ProfilePipelineAccess[]> {
    return firstValueFrom(
      this.http.put<{ data: ProfilePipelineAccess[] }>(this.url(owner, id), { pipelines }).pipe(
        take(1),
        map(response => response?.data ?? [])
      )
    );
  }
}
